// ../../react-shim.js
import React from "react";

// src/use-descendant.tsx
import React2 from "react";
import { useSafeLayoutEffect, useForceUpdate } from "@nature-ui/hooks";
var useDescendant = (props) => {
  const {
    context,
    element,
    index: indexProp,
    disabled,
    focusable,
    ...rest
  } = props;
  const forceUpdate = useForceUpdate();
  const { register, unregister, descendants } = context;
  useSafeLayoutEffect(() => {
    if (!element) {
      forceUpdate();
    }
    if (disabled && !focusable)
      return;
    register({
      element,
      disabled,
      focusable,
      ...rest
    });
    return () => {
      if (element) {
        unregister(element);
      }
    };
  }, [element, ...Object.values(rest)]);
  const index = indexProp ?? descendants.findIndex((descendant) => descendant.element === element);
  return index;
};
var useDescendants = () => {
  const [descendants, setDescendants] = React2.useState([]);
  const register = React2.useCallback(
    ({ element, ...rest }) => {
      if (!element)
        return;
      setDescendants((prevDescendants) => {
        if (prevDescendants.find((item) => item.element === element) == null) {
          const index = prevDescendants.findIndex((item) => {
            if (!item.element || !element)
              return false;
            return Boolean(
              item.element.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING
            );
          });
          const newItem = { element, ...rest };
          if (index === -1) {
            return [...prevDescendants, newItem];
          }
          return [
            ...prevDescendants.slice(0, index),
            newItem,
            ...prevDescendants.slice(index)
          ];
        }
      });
    },
    []
  );
  const unregister = React2.useCallback((element) => {
    if (!element)
      return;
    setDescendants(
      (_descendants) => _descendants.filter((descendant) => element !== descendant.element)
    );
  }, []);
  const context = React2.useMemo(() => {
    return { descendants, register, unregister };
  }, [descendants, register, unregister]);
  return context;
};
export {
  useDescendant,
  useDescendants
};
